/*
 * @Author: wm
 * @Date: 2020-08-07 15:22:41
 * @LastEditTime: 2020-08-07 15:29:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /m-live-square/src/config/index.ts
 */
import { ENVConfig, IBaseConfig } from './types';

const BaseConfig = {
    pid: '',
    shareData: {
        title: '看直播，轻松找工作',
        desc: '多家知名企业正在直播热招中，快来一起围观>>>',
        imgUrl: 'https://pic1.58cdn.com.cn/nowater/cxnomark/n_v29cb9bc3f340c457db1933a8444cd1b0e.png',
    },
    liveSquareUrl: 'https://h5-cdn.58.com/git/hrg-fe/zp-resume/m-live-square-new/index.html#/',
    liveVersion: '10.5.0',
    liveGJVersion: '10.7.0',
    log: {
        
    }
};

const config: ENVConfig & IBaseConfig = {
    ...BaseConfig,
    ...require(`./${process.env.NODE_ENV}`).default,
};

export default config;